import type { SelectDropdownMultilineProps } from "./select-dropdown-multiline.type";

export const SelectDropdownMultiline = ({
  dropdownNode,
  multilineOptions,
}: SelectDropdownMultilineProps) => {
  const className = "ant-select-dropdown-multiline-options";

  return (
    <>
      <style>{`.${className}{--app-select-option-multiline-count:${multilineOptions};}`}</style>
      <div className={className}>{dropdownNode}</div>
    </>
  );
};
